import React, { Component } from 'react'
import CardQuarterHeight from './../../components/cards/CardQuarterHeight'
import { Grid, Row, Col } from 'react-bootstrap'
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton'

const styles = {

  top2: {
    marginTop: 15
  }
}

export class MealPlan extends Component {
  render() {
    return (
      <div>
        <div className="subheader">
          <h4>Meal Plan</h4>
        </div>
        <Grid>
          <Row className="show-grid center">
            <Col lg={8} lgOffset={2} sm={12}>
              <CardQuarterHeight>
                <div className="some-pad">Your meal plan information will be collected after you have been housed.</div>
              </CardQuarterHeight>

            </Col>
          </Row>
        </Grid>

      </div>
    )
  }
}

export default MealPlan



// WEBPACK FOOTER //
// ./src/views/pages/meal-plan/index.js